/* tslint:disable */
type TipoLinhaTelefonicaEnum =
  'CELULAR' |
  'FIXO' |
  'FAX';
module TipoLinhaTelefonicaEnum {
  export const CELULAR: TipoLinhaTelefonicaEnum = 'CELULAR';
  export const FIXO: TipoLinhaTelefonicaEnum = 'FIXO';
  export const FAX: TipoLinhaTelefonicaEnum = 'FAX';
  export function values(): TipoLinhaTelefonicaEnum[] {
    return [
      CELULAR,
      FIXO,
      FAX
    ];
  }
}

export { TipoLinhaTelefonicaEnum }